<template>
	<div>
		<div class="clearfix"></div>
		<div class="row">
			<div class="col-md-12 col-sm-12 col-xs-12">
				<div class="form-group">
					<div class="col-lg-12 col-md-12 text-center" v-if="!transactionData.msg">
						<h3>{{ $t('please_wait_verifying_payment') }}</h3>
						<div style="width:40%; margin:0 auto;">
							<div class="lds-ellipsis">
								<div></div>
								<div></div>
								<div></div>
								<div></div>
							</div>
						</div>
					</div>
					<div class="col-lg-12 col-md-12 text-center" v-if="transactionData">
						<div class="" v-if="transactionData.msg === 'pending'">
							<h1><i class="fa fa-spinner" aria-hidden="true"></i></h1>
							<h1>{{ $t('pending') }}</h1>
							{{ $t('payment_is_pending_need_completed') }}
							<br />
						</div>
						<div class="" v-else-if="transactionData.msg === 'paid'">
							<h1><i class="fa fa-check" aria-hidden="true"></i></h1>
							<h1>{{ $t('PAID') }}</h1>
							{{ $t('thank_you_payment_completed') }}
							<br />
						</div>
						<div class="" v-else-if="transactionData.msg === 'already_processed'">
							<h1><i class="fa fa-check" aria-hidden="true"></i></h1>
							<h1>{{ $t('already_processed') }}</h1>
							{{ $t('transaction_already_processed') }}
							<br />
						</div>
						<div class="payment-error" v-else-if="transactionData.msg === 'failed'">
							<h1><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></h1>
							<h1>{{ $t('error') }}</h1>
							{{ $t('transaction_failed') }}<br/>
							Puedes ponerte en contacto con nosotros enviándonos un ticket o enviándonos un correo electrónico a info@electronicacar.com.
							<br />
						</div>
						<div class="payment-error" v-else-if="transactionData.msg === 'canceled'">
							<h1><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></h1>
							<h1>{{ $t('canceled') }}</h1>
							{{ $t('transaction_canceled') }}<br/>
							Puedes ponerte en contacto con nosotros enviándonos un ticket o enviándonos un correo electrónico a info@electronicacar.com.
							<br />
						</div>
						<div class="payment-error" v-else-if="transactionData.msg === 'trx_does_not_exist'">
							<h1><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></h1>
							<h1>{{ $t('error') }}</h1>
							{{ $t('transaction_error') }}<br/>
							Puedes ponerte en contacto con nosotros enviándonos un ticket o enviándonos un correo electrónico a info@electronicacar.com.
							<br />
						</div>
						<div class="payment-error" v-else>
							<em>Se ha producido un error. A continuación, encontrará la información técnica en inglés. ¿Podría ponerse en contacto con nosotros y copiar este texto a continuación para enviárnoslo? De esta manera, podremos ayudarle mejor.</em>
							<h1><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></h1>							
							<h1>{{ $t('error') }}</h1>
							{{ transactionData.msg }}<br/>
							Puedes ponerte en contacto con nosotros enviándonos un ticket o enviándonos un correo electrónico a info@electronicacar.com.
							<br />
						</div><br />
						<router-link :to="{ path: '/portal/transactions' }" tag="a" class="btn btn-lg btn-primary"><i
								class="fas fa-arrow-circle-left"></i> {{ $t('click_transaction_overview') }}</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data: function () {
		return {
			transactionData: {},
			transactionCode: this.$route.params.transactioncode
		}
	},
	mounted: function () {

		var url_string = window.location.href;
		var url = new URL(url_string);
		var payerId = url.searchParams.get("PayerID");
		var payment_intent = url.searchParams.get("payment_intent");
		if (typeof (payerId) == 'undefined' || payerId == null) { // Payer Id has not been set. This means that the transaction probably failed - use the token to check		
			payerId = url.searchParams.get("token");
		}

		if (this.transactionCode) {
			Webservice.verifyTransaction(this.transactionCode, payerId, payment_intent).then((resp) => {
				this.transactionData = resp.data;
				if (resp.data) {
					return;
				}
			}).catch((error) => {
				swal('Whoops', this.$t('error_could_not_verify_payment'), 'warning');
			});
		} else {
			swal('Whoops', this.$t('error_could_not_verify_payment'), 'warning');
		}
	}
}
</script>
<style>
.payment-error { color: #ff7900; }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Transactions/Verify.vue